import ConsentProvider from './src/context/ConsentContext';

export const wrapRootElement = ConsentProvider;
